import { render, staticRenderFns } from "./find-password.vue?vue&type=template&id=2f101444&scoped=true"
import script from "./find-password.vue?vue&type=script&lang=ts"
export * from "./find-password.vue?vue&type=script&lang=ts"
import style0 from "./find-password.vue?vue&type=style&index=0&id=2f101444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f101444",
  null
  
)

export default component.exports